import { Paper, styled } from '@mui/material';

const PREFIX = 'DropDown';

export const classes = {
  dropdown: `${PREFIX}-dropdown`,
};

export const DropdownPaper = styled(Paper)(({ theme }) => ({
  opacity: 0,
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
  position: 'fixed',
  transform: 'translateX(-10px)',
  transition: 'opacity 0.5s, transform 0.25s, top 250ms linear 250ms',
  visibility: 'hidden',
  zIndex: 9999,
}));
